import React from 'react';
import * as PropTypes from 'prop-types';
import Card from '@lwt-helix/card';
import { ButtonIcon } from '@lwt-helix/buttons';
import { Col, Row } from '@lwt-helix/layout';
import { muted, cardHeader, cardSubheader } from '../common/styles/Common.css';

const ViewSettingsCard = props => {
    return (
        <Card
            dataLwtId='settings-card'
            raised
            headerProps={{
                children: <>
                    <div style={cardHeader}>My Settings</div>
                    <div style={cardSubheader}>Password and Security Settings</div>
                </>
            }}
            bodyProps={{
                children: <>
                    <Row>
                    <Col>
                        <div style={muted}>Username</div>
                        <div>{props.username}</div>
                    </Col>
                    </Row>
                    <Row>
                    <Col>
                        <hr />
                    </Col>
                    </Row>
                    <Row>
                    <Col>
                        <div style={muted}>Password</div>
                        <div>**********</div>
                    </Col>
                    <Col>
                        <ButtonIcon
                            dataLwtId="edit-password"
                            iconName="edit"
                            className="float-right"
                            onClick={props.editPassword}
                        />
                    </Col>
                    </Row>
                </>
            }}
        />
    );
};

ViewSettingsCard.propTypes = {
    username: PropTypes.string.isRequired,
    editPassword: PropTypes.func.isRequired,
};

export default ViewSettingsCard;